import LabServiceModel from "@/models/LabServiceModel";
import ManagedListKinModel from "@/models/lab/ManagedListKinModel";
import AttributeListCollection from "@/collections/lab/AttributeListCollection";

export default class ManagedListModel extends LabServiceModel {
  modelName() {
    return "managed-list";
  }
  defaults() {
    return {
      id: null,
      parent_id: null,
      type: null,
      sub_type: null,
      list: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      parent: null,
      attribute_lists: [],
      children: []
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      parent_id: val => this.nullStringMutator(val),
      type: val => this.nullStringMutator(val),
      sub_type: val => this.nullStringMutator(val),
      list: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val),
      parent: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getAttributeList() {
    return this.getRelatedCollection(
      new AttributeListCollection(),
      "attribute_lists"
    );
  }
  getParent() {
    return this.getRelatedModel(ManagedListKinModel, "parent");
  }
}
